import { logger } from "c7-logger";

import { PaymentMethodScriptType } from "checkout-query-client/hooks/use-merchant-settings";

import { sendCustomAction } from "datadog-loader/loader";

type UseLoadScriptProps = {
  script: PaymentMethodScriptType;
  onLoad: (cb: () => void) => void;
  onSuccess: () => void;
  onError: () => void;
};

const scriptAlreadyExists = (id: string) =>
  document.querySelector(`script#${id}`);

export const loadScript = ({
  script: { id, url, crossOrigin, integrity },
  onLoad,
  onSuccess,
  onError,
}: UseLoadScriptProps) => {
  const appendSdkScript = () => {
    const script = document.createElement("script");

    script.async = true;
    script.id = id;
    script.src = url;
    if (crossOrigin) {
      script.crossOrigin = "anonymous";
    }
    if (integrity) {
      script.integrity = integrity;
    }
    script.onload = () => {
      onSuccess();
    };
    script.onerror = () => {
      onError();
      logger.error(`Failed to load payment method script: ${id}`);
      sendCustomAction({
        name: "FailedToLoad",
        context: { reason: `Failed to load payment method script: ${id}` },
      });
    };

    document.body.append(script);
  };

  //remove previous script if it already was added.
  const prevScript = scriptAlreadyExists(id);
  if (prevScript) {
    document.body.removeChild(prevScript);
  }
  onLoad(appendSdkScript); // start up loading state
};
